import React,  { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Pagination,
  Popover,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Spinner } from "react-bootstrap";
import { DownloadCSVFileForAdmin } from "../../contexts/WorkspaceUtils";
import CommonToast from "../Common_Components/CommonToast";
import sourceUrl from "../../api/Source.api";

const customTextFieldStylesForInvalid = (isInvalid) => {
    return {
      "& .MuiInputLabel-root": {
        fontFamily: "Inter",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "24px",
        letterSpacing: "0.5px",
        color: "rgba(255, 255, 255, 0.80)",
        "&.Mui-focused": {
          color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80)",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFFFFF",
        padding:"13px 10px"
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&:hover fieldset": {
          borderColor: isInvalid ? "#F2B8B5" : "rgba(255, 255, 255, 0.80)",
        },
        "&.Mui-focused fieldset": {
          borderColor: isInvalid
            ? "#F2B8B5 !important"
            : "rgba(255, 255, 255, 0.80) ",
        },
      },
      "& .MuiOutlinedInput-root.Mui-focused .MuiInputLabel-root": {
        color: isInvalid ? "#F2B8B5 !important" : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isInvalid
          ? "#F2B8B5 !important"
          : "rgba(255, 255, 255, 0.80) ",
      },
      "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "rgba(255, 255, 255, 0.40)",
      },
    };
  };

const DownlaodCSV = () => {

    const [selectedOptionForCSVDownload, setSelectedOptionForCSVDownload] = useState("custom");
    const [selectedStartDateForCSVDownload, setSelectedStartDateForCSVDownload] = useState("");
    const [selectedEndDateForCSVDownload, setSelectedEndDateForCSVDownload] = useState("");
    const [DownloadCSVLoader, setDownloadCSVLoader] = useState(false);
    const [fileCreated, setFileCreated] = useState(true);
    const [openToast, setOpen] = useState(false);
    const [content, setContent] = useState("");
    const [iconType, setIconType] = useState("success");
    const [email, setEmail] = useState("");
    const [file, setFile] = useState()
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const token  = localStorage.getItem('token');

const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

const handleOptionSelectedForCSVDOwnload = (option) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const formattedToday = `${year}-${month}-${day}`;

  if (option === "today") {
    setSelectedStartDateForCSVDownload(formattedToday);
    setSelectedEndDateForCSVDownload(formattedToday);
  } 
  else if (option === "this_week") {
    // Calculate Monday of this week (from today backward)
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // How many days back to Monday
    
    const monday = new Date(today);
    monday.setDate(today.getDate() - diffToMonday);
    
    const mondayYear = monday.getFullYear();
    const mondayMonth = String(monday.getMonth() + 1).padStart(2, '0');
    const mondayDay = String(monday.getDate()).padStart(2, '0');
    const formattedMonday = `${mondayYear}-${mondayMonth}-${mondayDay}`;
    
    setSelectedStartDateForCSVDownload(formattedMonday);
    setSelectedEndDateForCSVDownload(formattedToday);
  }
  else if (option === "this_month") {
    // First day of current month
    const firstDayOfMonth = new Date(year, today.getMonth(), 1);
    const firstDayYear = firstDayOfMonth.getFullYear();
    const firstDayMonth = String(firstDayOfMonth.getMonth() + 1).padStart(2, '0');
    const firstDayDay = String(firstDayOfMonth.getDate()).padStart(2, '0');
    const formattedFirstDay = `${firstDayYear}-${firstDayMonth}-${firstDayDay}`;
    
    setSelectedStartDateForCSVDownload(formattedFirstDay);
    setSelectedEndDateForCSVDownload(formattedToday);
  }else if(option === "all_time"){
    setSelectedStartDateForCSVDownload("");
    setSelectedEndDateForCSVDownload("");
  }

  setSelectedOptionForCSVDownload(option);
}

  const downloadFile =async () => {
  const downloadUrl = file?.download_url
  const filename =  file?.file_name

  try {
    // Fetch the file as a blob
    const response = await window.__originalFetch(downloadUrl);
    const blob = await response.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
      setOpen(true);
      setContent("Download will begin shortly.");
      setIconType("success");
    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download failed:", error);
     setOpen(true)
     setContent(error?.message)
     setIconType("error")
  }
  }

    const HandleCreateCSVFile =async () => {
        if(email == ""){
            setOpen(true)
            setContent("Please enter Valid Email")
            setIconType("error")
            return 
        }
        setDownloadCSVLoader(true)
        setFileCreated(true)
      try{
        const req = await DownloadCSVFileForAdmin(email, selectedStartDateForCSVDownload, selectedEndDateForCSVDownload)
        const res = await req.json()
        // console.log("Result before batch call", res)
        if(res.status && res?.data?.id){
        // await downloadFile(res.data)
        // setOpen(true)
        // setContent(res?.message)
        // setIconType("success")
        setFile(res.data)
        await pollBatchStatus(res?.data?.id);
        }else{
        setOpen(true)
        setContent(res?.message)
        setIconType("error")
        setDownloadCSVLoader(false)
        }
      }catch(error){
         console.error("Download failed:", error);
         setOpen(true)
         setContent(error?.message)
         setIconType("error")
         setDownloadCSVLoader(false)
      }
  }

  const pollBatchStatus = async (id) => {
  let retries = 0;
  const maxRetries = 20; // e.g., ~2 mins if interval = 6s
  const interval = 3000; // 3 sec

  const intervalId = setInterval(async () => {
    try {
      const response = await fetch(`${sourceUrl}/admin/callingAgent/status/${id}`,{
      method: "GET",
      credentials: "include",
      headers: {
              "Content-Type": "application/json",
      ...(isLoggedIn ? { Authorization: `Bearer ${token}` } : {}),
              }
      });
      const result = await response.json();
      // console.log("Result after batch call", result)
      if (result?.data?.status === "completed") {
        clearInterval(intervalId);
        setDownloadCSVLoader(false);

        // Show download button or auto download
        // await downloadFile(result.url);
        setFile((prev) => ({
            ...prev,
            download_url: result?.data?.url,
          }));
        setOpen(true);
        setContent("Your file is ready! Click the Download button to get it.");
        setIconType("success");
        setFileCreated(false)
      } else if (result.data.status === "failed") {
        clearInterval(intervalId);
        setDownloadCSVLoader(false);
        setOpen(true);
        setContent("File generation failed. Try again later.");
        setIconType("error");
        setDownloadCSVLoader(false)
      } else {
        retries++;
        if (retries >= maxRetries) {
          clearInterval(intervalId);
          setDownloadCSVLoader(false);

          setOpen(true);
          setContent("Request timed out. Please try again later.");
          setIconType("error");
        }
      }
    } catch (err) {
      clearInterval(intervalId);
      setDownloadCSVLoader(false);
      setOpen(true);
      setContent("Error while checking file status.");
      setIconType("error");
    }
  }, interval);
};


  const renderCalendra = () => {
    return (
      <>
      {
         ( selectedOptionForCSVDownload == "custom" || selectedOptionForCSVDownload == "today" || selectedOptionForCSVDownload == "this_week"  || selectedOptionForCSVDownload == "this_month" )?
           <Box> 
            <Box sx={{display:"flex", flexDirection:"row", columnGap:"20px", margin : "24px 0px"}}>
                              <TextField disabled={selectedOptionForCSVDownload !=="custom"}
                                type="date"
                                value={selectedStartDateForCSVDownload}
                                onChange={(e)=>setSelectedStartDateForCSVDownload(e.target.value)}
                                label="Start Date*"
                                variant="outlined"
                                sx={{
                                  ...customTextFieldStylesForInvalid(false),
                                  maxHeight: "48px",
                                  "& .MuiInputAdornment-root": {
                                    color: "rgba(255, 255, 255, 0.8)", // custom text color
                                    fontWeight: 500,
                                    fontSize: "16px",
                                  },
                                   "&:hover": {
                                    color: "rgba(255, 255, 255, 0.4)", // custom text color                                
                                  },
                                   "& .MuiOutlinedInput-root.Mui-disabled": {
                                    "& fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    }
                                  }
                                }}
                                 InputLabelProps={{
                                  shrink: true, // This will force the label to always appear above the input
                                }}
                                placeholder="Select start date"
                              />

                                <TextField disabled={selectedOptionForCSVDownload !=="custom"}
                                type="date"
                                value={selectedEndDateForCSVDownload}
                                onChange={(e)=>setSelectedEndDateForCSVDownload(e.target.value)}
                                label="End Date*"
                                variant="outlined"
                                sx={{
                                  ...customTextFieldStylesForInvalid(false),
                                  maxHeight: "48px",
                                  "& .MuiInputAdornment-root": {
                                    color: "rgba(255, 255, 255, 0.8)", // custom text color
                                    fontWeight: 500,
                                    fontSize: "16px",
                                  },
                                   "&:hover": {
                                    color: "rgba(255, 255, 255, 0.4)", // custom text color                             
                                  },
                                  "& .MuiOutlinedInput-root.Mui-disabled": {
                                    "& fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "rgba(255, 255, 255, 0.4)", 
                                    }
                                  }
                                }}
                                 InputLabelProps={{
                                  shrink: true, // This will force the label to always appear above the input
                                }}
                                placeholder="Select end date"
                              />
                            </Box>
           </Box>
          : null
      }

        <h5 style={{ display: "flex" }}>Enter User Email</h5>
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={handleEmailChange}
            style={{
              padding: "10px",
              minWidth: "300px",
              marginBottom: "10px",
              height: "50px",
              borderRadius: "10px",
              border: "none",
            }}
          />
          <br />
           <Box sx={{display:"flex", flexDirection:"row", columnGap:"16px", justifyContent:"flex-end"}}>
            <Button disabled={DownloadCSVLoader || email == ""}
                           onClick={HandleCreateCSVFile}
                           sx={{
                             width: "100%",
                            maxWidth:"250px",
                             height: "40px",
                             textTransform: "none",
                             fontFamily: "Inter",
                             fontSize: "16px",
                             fontWeight: 600,
                             textAlign: "center",
                             bgcolor: "rgba(246, 190, 107, 1)",
                             color: "rgba(23, 24, 44, 1)",
                             borderRadius: "8px",
                             "&:hover": {
                                   backgroundColor: "#ffd9aa", 
                             },
                           }}
                         >
                           {
                          DownloadCSVLoader ? <Spinner
                                  as="span"
                                  animation="border"
                                  size="md"
                                  role="status"
                                  aria-hidden="true"
                                /> : "Create File (.csv)"
                        } 
            </Button>
            <Button sx={{
                             width: "100%",
                            maxWidth:"250px",
                             height: "40px",
                             textTransform: "none",
                             fontFamily: "Inter",
                             fontSize: "16px",
                             fontWeight: 600,
                             textAlign: "center",
                             bgcolor: "rgba(246, 190, 107, 1)",
                             color: "rgba(23, 24, 44, 1)",
                             borderRadius: "8px",
                             "&:hover": {
                                   backgroundColor: "#ffd9aa", 
                             },
                           }}
                 disabled={fileCreated} onClick={downloadFile}>{ " Download data(.csv)"}</Button>
            </Box>
    </>
    )
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <h2>Downlaod CSV</h2>
      <Box
        sx={{
          maxWidth: "474px",
          width: "100%",
          bgcolor: "#282D51",
          color: "#FFFFFF",
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <Typography sx={{ p: 2 }}>Download data</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "12px",
            marginBottom: "24px",
            flexWrap: "wrap",
            border: "",
          }}
        >
          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#E6E0E9",
                  color: "#17182C",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 500,
                  padding: "4px 8px 4px 8px",
                  borderRadius: "4px",
                  textAlign: "center",
                },
              },
            }}
            title="Today"
          >
            <Box
              onClick={(e) => handleOptionSelectedForCSVDOwnload("today")}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: "8px",
                border:
                  selectedOptionForCSVDownload === "today"
                    ? "1px solid rgba(255, 255, 255, 0.30)"
                    : "1px solid rgba(255, 255, 255, 0.10)",
                padding: "8px 12px",
                cursor: "pointer",
                bgcolor:
                  selectedOptionForCSVDownload == "today"
                    ? "#373E6D"
                    : "transparent",
                color:
                  selectedOptionForCSVDownload === "today"
                    ? "#FFFFFF"
                    : "#CAC4D0",
                "&:hover": {
                  bgcolor:
                    selectedOptionForCSVDownload !== "today" && "#282D51",
                  color:
                    selectedOptionForCSVDownload !== "today"
                      ? "#CAC4D0"
                      : "#FFFFFF",
                },
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                Today
              </Typography>
            </Box>
          </Tooltip>

          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#E6E0E9",
                  color: "#17182C",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 500,
                  padding: "4px 8px 4px 8px",
                  borderRadius: "4px",
                  textAlign: "center",
                },
              },
            }}
            title="This week"
          >
            <Box
              onClick={() => handleOptionSelectedForCSVDOwnload("this_week")}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: "8px",
                border:
                  selectedOptionForCSVDownload === "this_week"
                    ? "1px solid rgba(255, 255, 255, 0.30)"
                    : "1px solid rgba(255, 255, 255, 0.10)",
                padding: "8px 12px",
                cursor: "pointer",
                bgcolor:
                  selectedOptionForCSVDownload == "this_week"
                    ? "#373E6D"
                    : "transparent",
                color:
                  selectedOptionForCSVDownload === "this_week"
                    ? "#FFFFFF"
                    : "#CAC4D0",
                "&:hover": {
                  bgcolor:
                    selectedOptionForCSVDownload !== "this_week" && "#282D51",
                  color:
                    selectedOptionForCSVDownload !== "this_week"
                      ? "#CAC4D0"
                      : "#FFFFFF",
                },
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                This week
              </Typography>
            </Box>
          </Tooltip>

          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#E6E0E9",
                  color: "#17182C",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 500,
                  padding: "4px 8px 4px 8px",
                  borderRadius: "4px",
                  textAlign: "center",
                },
              },
            }}
            title="This month"
          >
            <Box
              onClick={() => handleOptionSelectedForCSVDOwnload("this_month")}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: "8px",
                border:
                  selectedOptionForCSVDownload === "this_month"
                    ? "1px solid rgba(255, 255, 255, 0.30)"
                    : "1px solid rgba(255, 255, 255, 0.10)",
                padding: "8px 12px",
                cursor: "pointer",
                bgcolor:
                  selectedOptionForCSVDownload == "this_month"
                    ? "#373E6D"
                    : "transparent",
                color:
                  selectedOptionForCSVDownload === "this_month"
                    ? "#FFFFFF"
                    : "#CAC4D0",
                "&:hover": {
                  bgcolor:
                    selectedOptionForCSVDownload !== "this_month" && "#282D51",
                  color:
                    selectedOptionForCSVDownload !== "this_month"
                      ? "#CAC4D0"
                      : "#FFFFFF",
                },
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                This month
              </Typography>
            </Box>
          </Tooltip>

          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#E6E0E9",
                  color: "#17182C",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 500,
                  padding: "4px 8px 4px 8px",
                  borderRadius: "4px",
                  textAlign: "center",
                },
              },
            }}
            title="All time"
          >
            <Box
              onClick={() => handleOptionSelectedForCSVDOwnload("all_time")}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: "8px",
                border:
                  selectedOptionForCSVDownload === "all_time"
                    ? "1px solid rgba(255, 255, 255, 0.30)"
                    : "1px solid rgba(255, 255, 255, 0.10)",
                padding: "8px 12px",
                cursor: "pointer",
                bgcolor:
                  selectedOptionForCSVDownload == "all_time"
                    ? "#373E6D"
                    : "transparent",
                color:
                  selectedOptionForCSVDownload === "all_time"
                    ? "#FFFFFF"
                    : "#CAC4D0",
                "&:hover": {
                  bgcolor:
                    selectedOptionForCSVDownload !== "all_time" && "#282D51",
                  color:
                    selectedOptionForCSVDownload !== "all_time"
                      ? "#CAC4D0"
                      : "#FFFFFF",
                },
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                All time
              </Typography>
            </Box>
          </Tooltip>

          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: "#E6E0E9",
                  color: "#17182C",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 500,
                  padding: "4px 8px 4px 8px",
                  borderRadius: "4px",
                  textAlign: "center",
                },
              },
            }}
            title="Custom date range"
          >
            <Box
              onClick={() => handleOptionSelectedForCSVDOwnload("custom")}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                borderRadius: "8px",
                border:
                  selectedOptionForCSVDownload === "custom"
                    ? "1px solid rgba(255, 255, 255, 0.30)"
                    : "1px solid rgba(255, 255, 255, 0.10)",
                padding: "8px 12px",
                cursor: "pointer",
                bgcolor:
                  selectedOptionForCSVDownload == "custom"
                    ? "#373E6D"
                    : "transparent",
                color:
                  selectedOptionForCSVDownload === "custom"
                    ? "#FFFFFF"
                    : "#CAC4D0",
                "&:hover": {
                  bgcolor:
                    selectedOptionForCSVDownload !== "custom" && "#282D51",
                  color:
                    selectedOptionForCSVDownload !== "custom"
                      ? "#CAC4D0"
                      : "#FFFFFF",
                },
              }}
            >
              <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
                Custom date range
              </Typography>
            </Box>
          </Tooltip>
        </Box>
        {renderCalendra()}
      </Box>
      <CommonToast open={openToast} onClose={handleClose} content={content} iconType={iconType} bgColor="#282D51"/>
    </div>
  );
};

export default DownlaodCSV;
